import { render } from "./MortgageCalculator.vue?vue&type=template&id=4f312280"
import script from "./MortgageCalculator.vue?vue&type=script&lang=js"
export * from "./MortgageCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__